import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { GetTenantByNameResponse } from 'src/types/tenant';

/**
 * Get tenant by name from the API
 * Used for automatic tenant resolution in single-tenant mode
 */
const getTenantByName = async (
  tenantName: string,
): Promise<GetTenantByNameResponse> => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetTenantByNameResponse>(
    `/shared/tenants/name/${encodeURIComponent(tenantName)}`,
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to fetch tenant by name');
};

// Mock data for development/testing
const _mockData: GetTenantByNameResponse = {
  success: true,
  tenant: {
    id: 'cmbfps2k6000fpf2x7c0q1og2',
    name: 'MOSQAFairway',
    schema: 'tenant_schema_wdrk8v5u99as7wpwk0dnmfuc',
    status: 'active',
    configuration: {},
    createdAt: '2025-06-02T23:21:48.534Z',
    updatedAt: '2025-06-02T23:21:48.534Z',
  },
};

export default getTenantByName;
